module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add text-pic5.f9cbaa07.jpg";